
export interface ConfigureDataArchivalOperationResult {
    raftCommandIndex: number;
}